import request from '@/utils/request'

export function getLeftTypeList() {
  return request({
    url: '/index/matrix/getLeftTypeList',
    headers: {
      // isToken: false
    },
    method: 'post',
  })
}

export function getTopMajorList(query) {
  return request({
    url: '/index/matrix/getTopMajorList',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getParentMajorList(query) {
  return request({
    url: '/index/matrix/getParentMajorList',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getMajorList(query) {
  return request({
    url: '/index/matrix/getMajorList',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getAddrTree() {
  return request({
    url: '/index/matrix/getAddrTree',
    headers: {
      // isToken: false
    },
    method: 'post'
  })
}

export function analyzeMajorAcademy(query) {
  return request({
    url: '/index/matrix/analyzeMajorAcademy',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}


export function exportMajorAcademy(query) {
  return request({
    url: '/index/matrix/exportMajorAcademy',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function queryCollege(query) {
  return request({
    url: '/index/matrix/queryCollege',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function analyzeClgMajor(query) {
  return request({
    url: '/index/matrix/analyzeClgMajor',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function exportClgMajor(query) {
  return request({
    url: '/index/matrix/exportClgMajor',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function analyzeIndustryRate(query) {
  return request({
    url: '/index/matrix/analyzeIndustryRate',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getSectorPage(query) {
  return request({
    url: '/index/matrix/getSectorPage',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function analyzeMajorCollegeBySector(query) {
  return request({
    url: '/index/matrix/analyzeMajorCollegeBySector',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function exportMajorCollegeBySector(query) {
  return request({
    url: '/index/matrix/exportMajorCollegeBySector',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getMajorDataByMajor(query) {
  return request({
    url: '/index/matrix/getMajorDataByMajor',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function queryAcademyRank(query) {
  return request({
    url: '/index/matrix/queryAcademyRank',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}


export function exportAcademyReport(query) {
  return request({
    url: '/index/matrix/exportAcademyReport',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getUserMajorGroup(query) {
  return request({
    url: '/index/matrix/getUserMajorGroup',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function createMajorGroup(query) {
  return request({
    url: '/index/matrix/createMajorGroup',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getGroupParentMajorList(query) {
  return request({
    url: '/index/matrix/getGroupParentMajorList',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getGroupTopMajorList(query) {
  return request({
    url: '/index/matrix/getGroupTopMajorList',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getGroupMajorList(query) {
  return request({
    url: '/index/matrix/getGroupMajorList',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getGroupMajor(query) {
  return request({
    url: '/index/matrix/getGroupMajor',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function addGroupMajor(query) {
  return request({
    url: '/index/matrix/addGroupMajor',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function removeGroupMajor(query) {
  return request({
    url: '/index/matrix/removeGroupMajor',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getSameIndustryData(query) {
  return request({
    url: '/index/matrix/getSameIndustryData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getSameIndustryData2(query) {
  return request({
    url: '/index/matrix/getSameIndustryData2',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getTopIndustryList(query) {
  return request({
    url: '/index/matrix/getTopIndustryList',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getGroupIndustryList(query) {
  return request({
    url: '/index/matrix/getGroupIndustryList',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getGroupCareerData(query) {
  return request({
    url: '/index/matrix/getGroupCareerData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function deleteUserGroup(query) {
  return request({
    url: '/index/matrix/deleteUserGroup',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function queryMajorEnroll(query) {
  return request({
    url: '/index/matrix/queryMajorEnroll',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function queryMajorEnrollYear(query) {
  return request({
    url: '/index/matrix/queryMajorEnrollYear',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function addGroupIndustry(query) {
  return request({
    url: '/index/matrix/addGroupIndustry',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function delGroupIndustry(query) {
  return request({
    url: '/index/matrix/delGroupIndustry',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getGroupMajorCareerData(query) {
  return request({
    url: '/index/matrix/getGroupMajorCareerData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getTargetMajorList(query) {
  return request({
    url: '/index/matrix/getTargetMajorList',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getGroupEditMajorList(query) {
  return request({
    url: '/index/matrix/getGroupEditMajorList',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function confirmCreateMajorGroup(query) {
  return request({
    url: '/index/matrix/confirmCreateMajorGroup',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function queryInnerCollege(query) {
  return request({
    url: '/index/matrix/queryInnerCollege',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getDegreeData(query) {
  return request({
    url: '/index/matrix/getDegreeData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getMajorIndustry(query) {
  return request({
    url: '/index/matrix/getMajorIndustry',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getIndustryData(query) {
  return request({
    url: '/index/matrix/getIndustryData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function calcuGroupIndustryCareer(query) {
  return request({
    url: '/index/matrix/calcuGroupIndustryCareer',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function queryCareerContent(query) {
  return request({
    url: '/index/matrix/queryCareerContent',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function queryGroupJobData(query) {
  return request({
    url: '/index/matrix/queryGroupJobData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function queryGroupJobData2(query) {
  return request({
    url: '/index/matrix/queryGroupJobData2',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function queryPositionListByJob(query) {
  return request({
    url: '/index/matrix/queryPositionListByJob',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function createGroupCustomJob(query) {
  return request({
    url: '/index/matrix/createGroupCustomJob',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function delGroupCustomJob(query) {
  return request({
    url: '/index/matrix/delGroupCustomJob',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function calcuJobTypicalTask(query) {
  return request({
    url: '/index/matrix/calcuJobTypicalTask',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function queryJobAttrData(query) {
  return request({
    url: '/index/matrix/queryJobAttrData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getTargetCareerStandardList(query) {
  return request({
    url: '/index/matrix/getTargetCareerStandardList',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getCareerLevelStandard(query) {
  return request({
    url: '/index/matrix/getCareerLevelStandard',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function calcuJobTypicalTaskByStandard(query) {
  return request({
    url: '/index/matrix/calcuJobTypicalTaskByStandard',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function calcuJobCareerAbility(query) {
  return request({
    url: '/index/matrix/calcuJobCareerAbility',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function queryJobAbilityData(query) {
  return request({
    url: '/index/matrix/queryJobAbilityData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getConfigData(query) {
  return request({
    url: '/index/matrix/getConfigData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function toExportAbilityReport(query) {
  return request({
    url: '/index/matrix/toExportAbilityReport',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getCareerTaskData(query) {
  return request({
    url: '/index/matrix/getCareerTaskData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function queryStandardLevelList(query) {
  return request({
    url: '/index/matrix/queryStandardLevelList',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function exportMajorEnroll(query) {
  return request({
    url: '/index/matrix/exportMajorEnroll',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function calcuJobCareerCourse(query) {
  return request({
    url: '/index/matrix/calcuJobCareerCourse',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getGroupPageConfig(query) {
  return request({
    url: '/index/matrix/getGroupPageConfig',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function exportGroupJobData(query) {
  return request({
    url: '/index/matrix/exportGroupJobData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getTyticalTaskData(query) {
  return request({
    url: '/index/matrix/getTyticalTaskData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function exportMajorIndustry(query) {
  return request({
    url: '/index/matrix/exportMajorIndustry',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function queryAllCollege(query) {
  return request({
    url: '/index/matrix/queryAllCollege',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}
